import { v4 as uuidv4 } from "uuid";

import { logger as baseLogger } from "@core/logger";

const STATE_STORAGE_KEY = "auth0_state";

const logger = baseLogger.getSubLogger({ name: "authState" });

type AuthState = {
  nonce: string;
  redirectUrl: string;
  expiresOn: number;
};

export const generateAuthState = (redirectUrl: string): string => {
  logger.debug("generateAuthState", { redirectUrl });
  const nonce = uuidv4();
  const state: AuthState = {
    nonce,
    redirectUrl,
    expiresOn: Date.now() + 30 * 60 * 1000, // 30 minutes expiry
  };

  // Store the state in localStorage
  localStorage.setItem(STATE_STORAGE_KEY, JSON.stringify(state));

  logger.debug("Generated auth state", { state });

  // Return just the nonce for the state parameter
  return nonce;
};

export const validateAndGetRedirectUrl = (state: string): string | null => {
  logger.debug("validateAndGetRedirectUrl", { state });
  // Get the latest state from localStorage
  const storedState = localStorage.getItem(STATE_STORAGE_KEY);
  if (!storedState) return null;

  try {
    const authState: AuthState = JSON.parse(storedState);
    if (authState.nonce === state && authState.expiresOn > Date.now()) {
      localStorage.removeItem(STATE_STORAGE_KEY);
      return authState.redirectUrl;
    }
  } catch (e) {
    logger.error("Error parsing stored auth state:", e);
  }

  logger.error("No valid auth state found");
  return null;
};

export const getLatestRedirectUrl = (): string | null => {
  const storedState = localStorage.getItem(STATE_STORAGE_KEY);
  if (!storedState) return null;

  const authState: AuthState = JSON.parse(storedState);
  return authState.redirectUrl;
};

export * from "./authState";
